export const header = [

    {
        href: "/about",
        title: "About"
    },


    {
        href: "/service",
        title: "Services"
    },


    {
        href: "/portfolio",
        title: "Portfolio"
    },

    {
        href: "/blog",
        title: "Blog"
    },

    {
        href: "/contact",
        title: "Contact Us"
    },

]